export type AudienceId =
  | 'particuliers'
  | 'professionnels'
  | 'entreprises'
  | 'tertiaire'
  | 'industrie'
  | 'collectivites'
  | 'coproprietes'
  | 'artisans'
  | 'agriculteurs';

export interface AudienceMeta {
  id: AudienceId;
  label: string;
  shortLabel: string;
  href: string;
  iconName:
    | 'home'
    | 'building-2'
    | 'factory'
    | 'landmark'
    | 'building'
    | 'hard-hat'
    | 'tractor'
    | 'briefcase'
    | 'cog';
  /** couleur d'accent par audience (clé Tailwind) */
  tone: 'brand' | 'lavender' | 'sage' | 'lavender-700' | 'brand-700' | 'accent';
  /** est-ce le pôle phare V3 ? */
  highlight?: boolean;
  /** courte description utilisée dans les menus / hub */
  tagline: string;
}

export const AUDIENCES: AudienceMeta[] = [
  {
    id: 'particuliers',
    label: 'Particuliers',
    shortLabel: 'Particulier',
    href: '/particuliers',
    iconName: 'home',
    tone: 'brand',
    tagline: 'Rénovez sans avancer un centime',
  },
  {
    id: 'professionnels',
    label: 'Professionnels',
    shortLabel: 'Pro',
    href: '/professionnels',
    iconName: 'building-2',
    tone: 'lavender',
    tagline: 'Payez moins cher vos factures pro',
  },
  {
    id: 'entreprises',
    label: 'Entreprises',
    shortLabel: 'Entreprise',
    href: '/entreprises',
    iconName: 'factory',
    tone: 'sage',
    tagline: 'Une stratégie énergie pilotée de A à Z',
  },
  {
    id: 'tertiaire',
    label: 'Tertiaire',
    shortLabel: 'Tertiaire',
    href: '/tertiaire',
    iconName: 'briefcase',
    tone: 'sage',
    tagline: 'Votre obligation -40 % gérée sans stress',
  },
  {
    id: 'industrie',
    label: 'Industrie',
    shortLabel: 'Industrie',
    href: '/industrie',
    iconName: 'cog',
    tone: 'sage',
    tagline: 'Audit obligatoire + primes sur vos équipements',
  },
  {
    id: 'collectivites',
    label: 'Collectivités',
    shortLabel: 'Collectivité',
    href: '/collectivites',
    iconName: 'landmark',
    tone: 'lavender-700',
    tagline: 'Financez vos bâtiments publics sans alourdir le budget',
  },
  {
    id: 'coproprietes',
    label: 'Copropriétés',
    shortLabel: 'Copropriété',
    href: '/coproprietes',
    iconName: 'building',
    tone: 'brand-700',
    tagline: 'Faites voter la rénovation de votre immeuble',
  },
  {
    id: 'artisans',
    label: 'Artisans RGE',
    shortLabel: 'Artisan',
    href: '/artisans',
    iconName: 'hard-hat',
    tone: 'accent',
    highlight: true,
    tagline: 'Vos primes CEE sans risque ni paperasse',
  },
  {
    id: 'agriculteurs',
    label: 'Agriculteurs',
    shortLabel: 'Agriculteur',
    href: '/agriculteurs',
    iconName: 'tractor',
    tone: 'accent',
    tagline: 'Des aides pour vos bâtiments d\'exploitation',
  },
];

export function getAudienceById(id: AudienceId): AudienceMeta | undefined {
  return AUDIENCES.find((a) => a.id === id);
}

export function getAudienceByPath(pathname: string): AudienceMeta | undefined {
  return AUDIENCES.find((a) => pathname.startsWith(a.href));
}
